import { StateInterface } from "./state";
import { MutationTree } from "vuex";
import Media from "@/classes/Media";
import ContentGroup from "@/classes/ContentGroup";

const mutation: MutationTree<StateInterface> = {
  /**
   * (re-)set all media files
   * @param mediaFiles
   */
  setMediaFiles: (state, mediaFiles: Array<Media | ContentGroup>) =>
    (state.mediaFiles = mediaFiles),

  /**
   * remove file via its id from state
   * @param fileId
   */
  removeMediaFile: (state, fileId) => {
    const index = state.mediaFiles.findIndex((x) => x.id === fileId);

    if (index !== undefined && index >= 0) {
      state.mediaFiles.splice(index, 1);
    } else {
      // If the mediafile we want to remove is inside a contentGroup we need to proceed as below
      let index1: number;
      let index2: number;
      for (let [index, file] of state.mediaFiles.entries()) {
        if (file instanceof ContentGroup) {
          let x = file.contentGroup.findIndex((x) => x.id === fileId);
          if (x !== undefined && x >= 0) {
            index1 = index;
            index2 = x;
            break;
          }
        }
      }
      if (state.mediaFiles[index1] instanceof ContentGroup) {
        (state.mediaFiles[index1] as ContentGroup).contentGroup.splice(
          index2,
          1
        );
      }
    }
  },
  /**
   * remove a content group
   * @param groupId
   */
  removeContentGroup: (state, groupId) => {
    const index = state.mediaFiles.findIndex(
      (x) => x.contentGroupId === groupId
    );

    if (index !== undefined && index >= 0) {
      state.mediaFiles.splice(index, 1);
    }
  },

  /**
   * To Show loading animation while rotating content
   * @param id of th erotated content
   */
  setMediaFilesWhileContentRotation: (state, id: string) => {
    const index = state.mediaFiles.findIndex((x) => x.id === id);
    const element = state.mediaFiles[index];

    // skip for content groups
    if (element instanceof ContentGroup) {
      return;
    }

    if (index !== undefined && index >= 0) {
      element.srcThumb = "/loading.mp4";
    }
  },

  updateContentInfo: (
    state,
    data: { contentId: string; name?: string; src?: string; duration?: string }
  ) => {
    let content: ContentGroup | Media;
    for (let file of state.mediaFiles) {
      if (file.getGroup()) {
        for (let groupFile of file.getGroup()!) {
          if (groupFile.id === data.contentId) {
            content = groupFile;
            break;
          }
        }
      }
      if (file.id === data.contentId) {
        content = file;
        break;
      }
    }

    if (!content) {
      console.log("ContentID not found.");
      return false;
    }
    console.log("MUTATION CALLED");
    // TODO
    if (data.name && content) content.name = data.name;
    if (data.src && content) content.setSrc(data.src);
    if (data.duration && content) content.setDuration(data.duration);
    return true;
  },

  updateContentGroupName: (
    state,
    data: { contentGroupId: string; name: string }
  ) => {
    const index = state.mediaFiles.findIndex(
      (x) => x.id === data.contentGroupId
    );
    if (!index) return false;
    const content = state.mediaFiles[index];
    if (!(content instanceof ContentGroup)) {
      return false;
    } else {
      if (data.name) content.name = data.name;
      return true;
    }
  },
};

export default mutation;
